import { type ReactNode, type FC } from 'react';
import classNames from 'classnames';

import PrevArrow from 'dibs-icons/exports/legacy/ArrowLeft.ts';
import NextArrow from 'dibs-icons/exports/legacy/ArrowRight.ts';

import styles from './styles.scss';

type Props = {
    disable: boolean;
    onNext: () => void;
    onPrevious: () => void;
    children: ReactNode;
};

const CarouselWrapper: FC<Props> = ({ disable, onNext, onPrevious, children }) => {
    const className = classNames(styles.mediaCarousel, {
        [styles.disable]: disable,
    });

    return (
        <div className={className} data-tn="carousel-wrapper">
            {/* Carousel */}
            {children}

            {/* Arrows */}
            <div className={styles.prev} onClick={onPrevious} data-tn="carousel-wrapper-prev">
                <PrevArrow className={styles.arrow} />
            </div>
            <div className={styles.next} onClick={onNext} data-tn="carousel-wrapper-next">
                <NextArrow className={styles.arrow} />
            </div>
        </div>
    );
};

export default CarouselWrapper;
